import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "No peripheral created yet", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_create_peripheral_modal = _resolveComponent("create-peripheral-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_table, {
      columns: _ctx.columns,
      "data-source": _ctx.peripherals,
      pagination: false,
      loading: _ctx.isLoading,
      scroll: {
      x: 600,
    },
      class: "peripherals-table"
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.key === 'createdAt')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.formatDate(record.createdAt)), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'actions')
          ? (_openBlock(), _createBlock(_component_a_popconfirm, {
              key: 1,
              title: "Are you sure you want to delete this peripheral?",
              okType: "danger",
              onConfirm: ($event: any) => (_ctx.onDeletePeripheral(record))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "danger",
                  shape: "circle"
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_DeleteOutlined)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onConfirm"]))
          : _createCommentVNode("", true),
        (column.key === 'status')
          ? (_openBlock(), _createBlock(_component_a_switch, {
              key: 2,
              checked: record.status,
              "onUpdate:checked": ($event: any) => ((record.status) = $event),
              loading: _ctx.updatingStatusIDs.includes(record._id),
              "checked-children": "ON",
              "un-checked-children": "OFF",
              onChange: ($event: any) => (_ctx.onUpdatePeripheralStatus(record))
            }, null, 8, ["checked", "onUpdate:checked", "loading", "onChange"]))
          : _createCommentVNode("", true)
      ]),
      headerCell: _withCtx(({ column }) => [
        (column.key === 'actions')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_a_button, {
                type: "primary",
                shape: "circle",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createPeripheralModalVisibility = true))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_PlusOutlined)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(column.title), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      emptyText: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createPeripheralModalVisibility = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Create peripheral")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["columns", "data-source", "loading"]),
    _createVNode(_component_create_peripheral_modal, {
      isVisible: _ctx.createPeripheralModalVisibility,
      gatewayId: _ctx.gatewayId,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createPeripheralModalVisibility = false)),
      onSuccess: _ctx.peripheralCreated
    }, null, 8, ["isVisible", "gatewayId", "onSuccess"])
  ], 64))
}